"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const global_1 = require("../global");
/**
 * ヘッダー 上スクロールで追従
 */
const fixedHeader = () => {
    let position = 0;
    window.addEventListener("scroll", () => {
        const scrollTop = window.scrollY;
        if (position > global_1.header.clientHeight &&
            scrollTop > position &&
            !global_1.header.classList.contains("is-menu-opened")) {
            global_1.header.classList.add("is-hidden");
            global_1.body.classList.remove("is-header-fixed");
        }
        else {
            global_1.header.classList.remove("is-hidden");
            global_1.body.classList.add("is-header-fixed");
        }
        position = scrollTop;
    });
};
/**
 * ヘッダー ハンバーガーメニュー
 */
const hamburgerMenu = () => {
    const menuButton = document.getElementById("js-headerMenu__button");
    const openMenu = () => {
        global_1.header === null || global_1.header === void 0 ? void 0 : global_1.header.classList.add("is-menu-opened");
    };
    const closeMenu = () => {
        global_1.header === null || global_1.header === void 0 ? void 0 : global_1.header.classList.remove("is-menu-opened");
        menuButton === null || menuButton === void 0 ? void 0 : menuButton.classList.remove("is-opened");
    };
    const onChangeMedia = () => {
        if (!global_1.mediaQueryLg.matches) {
            if (menuButton != null) {
                menuButton.classList.remove("is-opened");
                closeMenu();
            }
        }
    };
    menuButton === null || menuButton === void 0 ? void 0 : menuButton.addEventListener("click", (e) => {
        const target = e.currentTarget;
        target.classList.toggle("is-opened");
        if (target.classList.contains("is-opened")) {
            openMenu();
        }
        else {
            closeMenu();
        }
    });
    [...document.getElementsByClassName("js-headerMenu__close")].forEach((element) => {
        element.addEventListener("click", (e) => {
            closeMenu();
        });
    });
    global_1.mediaQueryLg.addEventListener("change", onChangeMedia);
};
const headerInit = () => {
    fixedHeader();
    hamburgerMenu();
};
exports.default = headerInit;
